import React from 'react';
export function validateEmail(mail)
{
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail);
}

export function validatePassword(password) {
    return password.length > 5 && password.length < 31 && !password.includes(' ');
}

export function validateConfirmPassword(a, b) {
    return a === b;
}

export function validatePhoneNumber(phone) {
    return phone.charAt(0) === '+' && phone.length > 5 && phone.length < 18
}
function trim (s, c) {
    if (c === "]") c = "\\]";
    if (c === "\\") c = "\\\\";
    return s.replace(new RegExp(
        "^[" + c + "]+|[" + c + "]+$", "g"
    ), "");
}

export function validateRegistration(data) {
    let errors = [];
    !validateEmail(data.email) && errors.push('Введен некорректный email.');
    !validatePassword(data.password) && errors.push('Пароль не соответствует требованиям.');
    !validateConfirmPassword(data.password, data.password_confirmation) && errors.push('Пароли не совпадают.')
    !validatePhoneNumber(data.phone) && errors.push('Номер телефона указан неверно.')
    if (!errors.length) return false;
    return (
        <span>
            {errors.map(e => <span>{e}<br /></span>)}
        </span>
    )
}